export default __webpack_public_path__ + "static/media/dropdown-arrow-white.7f19f504.svg";